export default "__VITE_ASSET__tMBVtyD3__"